import { render, staticRenderFns } from "./btnCreateUser.vue?vue&type=template&id=0ef7b29a"
import script from "./btnCreateUser.vue?vue&type=script&lang=js"
export * from "./btnCreateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports